//WINDOW VIEWPORT
//Fixes issues with CSS and JS not matching up at browser/window sizes due to the scrollbar.
(function($) {
	var e = window, a = 'inner';
	if (!('innerWidth' in window )) {
		a = 'client';
		e = document.documentElement || document.body;
	}

	$.fn.viewport = function(options) {
		if (this.get(0) != window)
			return { width: this.outerWidth(), height: this.outerHeight() };
		return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	};

	$.fn.viewportWidth = function(options) {
		if (this.get(0) != window)
			return this.outerWidth();
		return e[ a+'Width' ];
	};

	$.fn.viewportHeight = function(options) {
		if (this.get(0) != window)
			return this.outerHeight();
		return e[ a+'Height' ];
	};

	$.fn.filterByData = function(prop, val) {
		this.filter(
			function() { return $(this).data(prop)==val; }
			);
	};
})(jQuery);
jQuery(document).ready(function($) {
	// Global vars
	var windowWidth = 0,
	windowHeight = 0,
	scrollTop = 0,
	loading = true,
	$self, 
	$this,
	$window = $(window),	
	$document = $(document),	
	body = $('body'),
	header = $('.header'),
	main = $('.main'),
	footer = $('.footer');

	/*====================================
	Window Events
	====================================*/

	$window.resize(function(e) {
		//Causes resize not to fire if the windows haven't actually changed (great for IE8)
		// if (windowWidth != $window.viewportWidth() || windowHeight != $window.viewportHeight()) {
			windowWidth = $window.viewportWidth();
			windowHeight = $window.viewportHeight();

			//Code goes here
			main.css('min-height', windowHeight - ( header.outerHeight(true) + footer.outerHeight(true) ) );
			
		// }
	}).resize();

	/*====================================
	Document Events
	====================================*/

	$document.scroll(function(e) {
		scrollTop = $document.scrollTop();
		if (scrollTop > 100) {
			//forces browser to chill out for a moment if the page just loaded
			setTimeout(function() {
				body.addClass('scrolled');
			}, loading ? 500 : 0);
		} else {
			body.removeClass('scrolled');
		}
		// console.log(scrollTop);
	});

	if (window.pdfResources)
	{
		var monthNames = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December'
		];

		var getObjectKeys = function(obj, cast)
		{
			if (typeof cast == 'undefined')
				cast = true;

			var keys = [];
			for (var i in obj)
			{
				if (obj.hasOwnProperty(i))
					keys.push(i);
			}
			if (cast)
			{
				keys = $.map(keys, function(v) {
					return parseInt(v);
				});
				keys.sort(function(a, b) {
					return a - b;
				});
			}
			else
				keys.sort();

			return keys;
		};

		var getYearRanges = function() {
			var years = getObjectKeys(pdfResources),
				months,
				key,
				result = {};

			for (var i = 0; i < years.length; i++)
			{
				months = getObjectKeys(pdfResources[years[i]]);
				for (var j = 0; j < months.length; j++)
				{
					key = months[j] >= 8 ? (years[i] + '/' + (years[i] + 1)) : ((years[i] - 1) + '/' + years[i]);
					if (!result[key])
					{
						result[key] = {};
					}
					if (!result[key][months[j]])
					{
						result[key][months[j]] = {
							year: years[i],
							days: pdfResources[years[i]][months[j]]
						};
					}
				}
			}

			return result;
		};

		// Prepare data
		console.log('Processing pdfResource data...');
		pdfResources = getYearRanges();
		console.log('Processing complete');

		$document.on('change', '#year-filter', function() {
			var range = $(this).val(),
				monthFilter = $('#month-filter').val('');

			monthFilter.children(':not(.placeholder)').remove();

			if (range)
			{
				var months = getObjectKeys(pdfResources[range]);
				months.sort(function(a, b){
					if (a >= 8 && b >= 8) return a - b;
					else if (a < 8 && b < 8) return a - b;
					else return b - a;
				});

				for (var i = 0; i < months.length; i++)
				{
					monthFilter.append('<option value="' + range + '|' + months[i] + '">' + monthNames[months[i] - 1] + ' ' + pdfResources[range][months[i]].year + '</option>');
				}
			}

			monthFilter.change();
		});

		$document.on('change', '#month-filter', function() {
			var val = $(this).val(),
				dayFilter = $('#day-filter').val('');

			dayFilter.children(':not(.placeholder)').remove();

			if (val)
			{
				var parts = val.split('|'),
					range = parts[0],
					month = parseInt(parts[1]),
					year = pdfResources[range][month].year,
					days = getObjectKeys(pdfResources[range][month].days);

				for (var i = 0; i < days.length; i++)
				{
					dayFilter.append('<option value="' + range + '|' + month + '|' + days[i] + '">' + monthNames[month-1] + ' ' + days[i] + ', ' + year + '</option>');
				}
			}

			dayFilter.change();
		});

		$document.on('change', '#day-filter', function() {
			var val = $(this).val(),
				pdfContainer = $('#pdf-container').html('');

			location.hash = '';

			if (val)
			{
				var parts = val.split('|'),
					range = parts[0],
					month = parseInt(parts[1]),
					day = parseInt(parts[2]),
					year = pdfResources[range][month].year;

				location.hash = year + '-' + month + '-' + day;

				var resourcePath = pdfResources[range][month].days[day],
					frame;

				if (resourcePath.toLowerCase().substr(-4) == '.pdf')
				{
					frame = $('<a/>');
					frame
						.addClass('pdfemb-viewer')
						.attr({
							'href': resourcePath,
							'data-width': 'max',
							'data-height': 'max',
							'data-mobile-width': '500',
							'data-scrollbar': 'none',
							'data-download': 'on',
							'data-tracking': 'on',
							'data-newwindow': 'on',
							'data-pagetextbox': 'off',
							'data-scrolltotop': 'off',
							'data-startzoom': '100',
							'data-startfpzoom': '100',
							'data-toolbar': 'top',
							'data-toolbar-fixed': 'off',
						});

					frame.appendTo(pdfContainer).pdfEmbedder();
				}
				else
				{
					frame = $('<iframe frameborder="0" allowfullscreen/>');
					frame
						.attr('src', resourcePath);

					frame.appendTo(pdfContainer);
				}
			}
		});
		
		// Populate years
		(function() {
			var yearFilter = $('#year-filter'),
				ranges = getObjectKeys(pdfResources, false);

			for (var i = 0; i < ranges.length; i++)
				yearFilter.append('<option value="' + ranges[i] + '">' + ranges[i] + ' ' + yearSuffix + '</option>');
		})();

		// Load hash
		if (location.hash)
		{
			// wait for pdfEmbedder to load. *sigh*
			var timer = setInterval(function() {
				if (!$.fn.pdfEmbedder)
					return;
				clearInterval(timer);

				var dateParts = location.hash.substr(1).split('-'),
					year = parseInt(dateParts[0]),
					month = parseInt(dateParts[1]),
					day = parseInt(dateParts[2]);

				var range = month >= 8 ? (year + '/' + (year + 1)) : ((year - 1) + '/' + year);

				$document.one('change', '#year-filter', function() {
					$('#month-filter').val(range + '|' + month).change().trigger('populate');
				});
				$document.one('populate', '#month-filter', function() {
					$('#day-filter').val(range + '|' + month + '|' + day).change();
				});
				$('#year-filter').val(range).change();
			}, 100);
		}
	}


	//stops the browser loading delay 
	setTimeout(function() {
		loading = false;
	}, 500);

$('.matchHeight').matchHeight();

});//End doc.ready

// $(window).on('load', function (e) {
// 	$(window).resize();
// });